import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";

const GpsTrackerSlider = ({ t, handleAddGPSToCart }) => {
  const qrTagSwiperRef = useRef(null);

  const handlePrev = (swiperRef) => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const handleNext = (swiperRef) => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
  };

  return (
    <div className="qr-tag-list-container for-gps">
      <div className="qr-tag-list-container-title">
        <p> {t("choose gps tracker for your pet")} </p>
      </div>
      <div className="qr-tag-list-inside-container">
        <a className="prev" onClick={() => handlePrev(qrTagSwiperRef)}>
          <FontAwesomeIcon icon={faArrowLeft} size="sm" />
        </a>
        <a className="next" onClick={() => handleNext(qrTagSwiperRef)}>
          <FontAwesomeIcon icon={faArrowRight} size="sm" />
        </a>
        <Swiper
          ref={qrTagSwiperRef}
          wrapperClass="cards-swiper-container"
          spaceBetween={10}
          breakpoints={{
            0: {
              slidesPerView: 1.3,
            },
            768: {
              slidesPerView: 3,
            },
            1023: {
              slidesPerView: 4,
            },
            1024: {
              slidesPerView: 4,
            },
            1281: {
              slidesPerView: 4,
            },
            1601: {
              slidesPerView: 4,
            },
          }}
        >
          <SwiperSlide>
            <div className="qr-tag-card qr-tag-card-1">
              <div className="qr-tag-card-imgbox">
                <img
                  className="front-img"
                  src="img/circle-yellow-1.webp"
                  alt=""
                />
                <img className="back-img" src="img/1.png" alt="" />
              </div>
              <p className="qr-tag-name"> {t("yellow")} </p>
              <p className="qr-tag-price"> 215 {t("gel")} </p>
              <button
                className="order-now-button"
                onClick={() => handleAddGPSToCart("orange")}
              >
                {t("add to cart")} <ShoppingCart />
              </button>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="qr-tag-card qr-tag-card-2">
              <div className="qr-tag-card-imgbox">
                <img
                  className="front-img"
                  src="img/circle-blue-1.webp"
                  alt=""
                />
                <img className="back-img" src="img/2.png" alt="" />
              </div>
              <p className="qr-tag-name"> {t("blue")} </p>
              <p className="qr-tag-price"> 215 {t("gel")} </p>
              <button
                className="order-now-button"
                onClick={() => handleAddGPSToCart("cream")}
              >
                {t("add to cart")} <ShoppingCart />
              </button>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="qr-tag-card qr-tag-card-3">
              <div className="qr-tag-card-imgbox">
                <img
                  className="front-img"
                  src="img/circle-gray-1.webp"
                  alt=""
                />
                <img className="back-img" src="img/3.png" alt="" />
              </div>
              <p className="qr-tag-name"> {t("black")} </p>
              <p className="qr-tag-price"> 215 {t("gel")} </p>
              <button
                className="order-now-button"
                onClick={() => handleAddGPSToCart("black")}
              >
                {t("add to cart")} <ShoppingCart />
              </button>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="qr-tag-card qr-tag-card-4">
              <div className="qr-tag-card-imgbox">
                <span className="best-seller-badge">
                  {/* <FontAwesomeIcon icon={faCrown} /> */}
                  {t("most popular")}
                </span>
                <img
                  className="front-img"
                  src="img/circle-pink-1.webp"
                  alt=""
                />
                <img className="back-img" src="img/4.png" alt="" />
              </div>
              <p className="qr-tag-name"> {t("pink")} </p>
              <p className="qr-tag-price"> 215 {t("gel")} </p>
              <button
                className="order-now-button"
                onClick={() => handleAddGPSToCart("pink")}
              >
                {t("add to cart")} <ShoppingCart />
              </button>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default GpsTrackerSlider;
